export default __webpack_public_path__ + "static/media/multiple.f0ea7ad1.svg";